import { useMutation } from "react-query";
import getRegtankOnboardingDetail from "../services/getRegtankOnboardingDetail";

function useGetRegtankOnboardingDetail() {
  return useMutation(["getRegtankOnbordingDetail"], getRegtankOnboardingDetail);
}

export default useGetRegtankOnboardingDetail;
